<template>
    <el-dialog
        title="端口占用情况"
      :visible="visible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="cancel"
      width="80%"
    >
        <div v-for="(item, index) in results" :key="index" class="card">
            <h3>{{item.ip}}</h3>
            <div class="card_box" v-for="(port, pIndex) in item.ports" :key="pIndex">
                <div class="card_box_port">{{port.port}}</div>
                <div class="card_box_type">{{port.type}}</div>
            </div>
        </div>
        <div style="text-align:center;margin-top:20px;"><el-button @click="cancel">关闭</el-button></div>
    </el-dialog>
</template>
<script>
export default {
    props: {
        results: {
            type: Array
        },
        visible: {
            type: Boolean
        }
    },
    methods: {
        cancel(){
            this.$emit('closeBox')
        }
    }
}
</script>
<style scoped>
.card{
    margin: 0px 10px 10px 20px;
}
.card_box{
    margin: 6px 16px;
}
.card_box_port, .card_box_type{
    display: inline-block;
    margin: 6px 26px;
}
</style>